var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-wrapper',{attrs:{"title-translation-path":"admin.prints","subtitlePath":"admin.printsSubtitle","inputs":_vm.inputs}})}
var staticRenderFns = []

export { render, staticRenderFns }